<app-sample-info-panel [sample]="selectedSampleData" [isOpen]="isInfoPanelOpen" (closed)="onInfoPanelClosed()" />

<div class="sub-container">
  <div class="search">
    <app-table-search (filterChanged)="onFilterChanged($event)"></app-table-search>
  </div>
  <div class="not-search"></div>
  <app-buttons
    [isDisabled]="selectedSampleItems.length === 0"
    [name]="btnName"
    [buttonType]="btnMatFlat"
    [buttonStyle]="
      selectedSampleItems.length === 0 ? btnStyleFilledSmallForPrimaryBtnDisabled : btnStyleFilledSmallForPrimaryBtn
    "
    (buttonClickEvent)="onShareClicked()"
  >
  </app-buttons>
</div>
<app-table
  [displayedColumnLabels]="displayedColumnLabels"
  [showActionColumn]="true"
  [showMenuButton]="true"
  [showActionButtonsInPagination]="false"
  [displayedColumns]="displayedColumns"
  [dataSource]="dataSource"
  [showDownloadResultButton]="false"
  [showRunButton]="true"
  [showEditMenuItem]="true"
  [firstColumnClickable]="true"
  [isRowActive]="isRowActiveFn"
  (firstColumnClicked)="handleGetInfoClick($event.data)"
  (rowMenuOpened)="onRowMenuOpened($event)"
  (rowMenuClosed)="onRowMenuClosed()"
  (onRunMenuButtonClicked)="handleRunClick($event)"
  (onGetInfoMenuButtonClicked)="handleGetInfoClick($event)"
  (onGetAnalysisMenuButtonClicked)="handleGetAnalysisClick($event)"
  (onSampleEditButtonClicked)="handleSampleEditClick($event)"
  (onDeleteMenuButtonClicked)="openDeleteSampleModal($event)"
  (checkboxChanged)="handleCheckboxChange($event)"
  [isSampleTab]="true"
  [showCheckbox]="showCheckboxInTable"
>
</app-table>
